import { render, staticRenderFns } from "./ScreenLocker.vue?vue&type=template&id=04665117&scoped=true&"
import script from "./ScreenLocker.vue?vue&type=script&lang=ts&"
export * from "./ScreenLocker.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenLocker.vue?vue&type=style&index=0&id=04665117&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04665117",
  null
  
)

export default component.exports